import React, { Component } from 'react';
import {
    NavBar,
    BreadCumb,
    TimeOut,
    ClosureModal,
    PdfViewer,
    CashCutModal,
    ListModal,
    ConsolidateDocsModal
} from '../../components';
import { AuxiliarResponseModel } from '../../components/NewOrder';
import '../../css/tablesPOS.css';
import moment from "moment";
import config from "../../config";
import { connect } from 'react-redux';
import { DISPATCH_ID, CURRENCY, FORMAT_NUMBER, SYMBOL } from "../../libs/utils/Const";
import { ApiClient } from "../../libs/apiClient";
import { GeneralFunctions } from "../../components/index";
import $ from "jquery";
let _generalFunctions = new GeneralFunctions();
let apiClient = ApiClient.getInstance();

const months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
];

class BranchClosuresView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            TODAY: moment(new Date()).format('YYYY-MM-DD'),
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            EmployeesCashCutReports: [],
            BranchOfficeCreditNotes: [],
            CommentCloseDoc: '',
            idWorkShift: '',
            initialDate: moment(new Date()).format('YYYY-MM-DD'),
            finalDate: moment(new Date()).format('YYYY-MM-DD'),
            BranchOfficeInvoices: [],
            docsToPrint: [],
            sendMailModel: {
                to: '',
                subject: '',
                docEntry: ''
            },
            users: [],
            userSearch: '',
            cashCutsRecords: [],
            showCashCutModal: true,
            cashCut: "",
            totalCashCut: 0,
            totalAmountSales: 0,
            numSalesCashCut: 0,
            objCharge: {},
            extraPaymentsCashCut: {},
            headerCashCut: {},
            moneyOuts: [],
            moneyEntries: [],
            printhide: true,
            FailCardCodes: [],
            BlindCutByIdSession: [],
            idSessionSelected: "",
            simulateResult: [],
            responseBOC: {
                IM: null,
                IC: null,
                CC: null,
                CM: null,
            },
            DocDate: moment(new Date()).format('YYYY-MM-DD'),
            MonthDocument: 0,
            bankOptions: [],

        }
    }

    componentDidMount = async () => {
        await this.EmployeesCashCutReports();
        await this.SearchBranchOfficeInvoices();
        await this.GetUSers();
        await this.SetCurrentMonth();
        await this.searchBanksOptions();
    }

    SetCurrentMonth = async () => {
        const today = new Date();
        this.setState({
            MonthDocument: today.getMonth() ?? 1
        })
    }

    searchBanksOptions = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        let banksRes = await apiClient.getBanksOptions();
        enableSpinner(false);
        if (!banksRes?.status) {
            showAlert({ type: 'warning', timeOut: 5000, message: banksRes?.message || "Ocurrió un error al obtener el listado de bancos dispobiles para los depósitos" });
        } else {
            this.setState({
                bankOptions: banksRes?.data ?? []
            })
        }
    }

    ChangeDocDate = value => {
        this.setState({ DocDate: value })
    }


    GetUSers = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const { _user } = this.state
        const data = {
            codeBO: _user?.Branch.CodeBranchOffice,
        }
        enableSpinner(true);
        const responseApi = await apiClient.getSellersByBO(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return
        }

        this.setState({
            users: responseApi.data || []
        })
    }

    ChangeInitialDate = async (event) => {
        let initialDate = event.nativeEvent.target.value;
        await this.setState({
            initialDate,
        });
    };

    ChangeFinalDate = async (event) => {
        const { initialDate } = this.state;
        let finalDate = event.nativeEvent.target.value;
        if (finalDate < initialDate) {
            return;
        }
        await this.setState({
            finalDate,
        });
    };

    ChangeCommentCloseDoc = async (value) => {
        await this.setState({ CommentCloseDoc: value })
    }

    ChangeUserToSearch = async (value) => {
        this.setState({ userSearch: value })
    }

    EmployeesCashCutReports = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user } = this.state

        if (_user?.Branch.CodeBranchOffice === '' && _user?.Branch.CodeBranchOffice === undefined) return
        const data = {
            CodeBranchOffice: _user?.Branch.CodeBranchOffice
        };
        enableSpinner(true);
        let responseApi = await apiClient.BranchOfficeEmployeesCut(data);
        enableSpinner(false);
        // #consolidateDocsModal

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return
        }
        this.setState({
            EmployeesCashCutReports: responseApi.data || []
        })
    }

    CheckWorkSession = async () => {
        const { enableSpinner, notificationReducer: { showAlert }  } = this.props;
        enableSpinner(true);
        let responseApi = await apiClient.checkWorkSession();
        enableSpinner(false);
        if (responseApi.status === 1) {
            if (!responseApi.data.sessionStatus) {
                await this.ShowInitialCash();
            } else {
                this.setState({ idWorkShift: responseApi.data.idSession });
            }
        } else if (responseApi.status === 2) {
            showAlert({ type: "info", message: `${responseApi.message}`, timeout: 10000 });
            this.GotoDashboard();
        }
    };

    GotoDashboard = () => {
        this.props.history.push("/");
    };

    BranchOfficeGeneralCut = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user, CommentCloseDoc,  MonthDocument, DocDate } = this.state
        const data = {
            CodeBranchOffice: _user?.Branch.CodeBranchOffice,
            CommentCloseDoc: CommentCloseDoc,
            CutDate:  MonthDocument,
            DocDate: DocDate,
            idWorkShift: 0
        }

        enableSpinner(true);
        const responseApiCBO = await apiClient.BranchOfficeGeneralCut(data);
        enableSpinner(false);
        if (responseApiCBO.status !== 1) {
            if (responseApiCBO.status === 2) {
                showAlert({ type: "warning", message: responseApiCBO.message, timeOut: 99999 });
                await this.setState({
                    FailCardCodes: responseApiCBO.data || []
                })
                $("#failCardCodes").modal("show");
            } else {
                showAlert({ type: "error", message: responseApiCBO.message });
                return
            }
        }

        if (responseApiCBO.data.responseIC) {
            if (responseApiCBO.data.responseIC.status !== 1) {
                showAlert({ type: "info", message: responseApiCBO.data.responseIC.message, timeout: 999999 });
            } else {
                showAlert({ type: "success", message: responseApiCBO.data.responseIC.message, timeout: 999999 });
            }
        }
        if (responseApiCBO.data.responseIM) {
            if (responseApiCBO.data.responseIM.status !== 1) {
                showAlert({ type: "info", message: responseApiCBO.data.responseIM.message, timeout: 999999 });
            } else {
                showAlert({ type: "success", message: responseApiCBO.data.responseIM.message, timeout: 999999 });
            }
        }
        if (responseApiCBO.data.responseCC) {
            if (responseApiCBO.data.responseCC.status !== 1) {
                showAlert({ type: "info", message: responseApiCBO.data.responseCC.message, timeout: 999999 });
            } else {
                showAlert({ type: "success", message: responseApiCBO.data.responseCC.message, timeout: 999999 });
            }
        }
        if (responseApiCBO.data.responseCM) {
            if (responseApiCBO.data.responseCM.status !== 1) {
                showAlert({ type: "info", message: responseApiCBO.data.responseCM.message, timeout: 999999 });
            } else {
                showAlert({ type: "success", message: responseApiCBO.data.responseCM.message, timeout: 999999 });
            }
        }

        this.setState({ CommentCloseDoc: '' })

    }

    SearchBranchOfficeInvoices = async (type) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { finalDate, initialDate, _user } = this.state
        let data = {
            initialDate,
            finalDate,
            CodeBranchOffice: _user?.Branch.CodeBranchOffice,
            type
        }
        enableSpinner(true);
        let responseApi = await apiClient.SearchBranchOfficeInvoices(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: responseApi.message });
        }

        this.setState({
            BranchOfficeInvoices: responseApi.data || [],
        })
    }

    SearchBranchOfficeCreditNotes = async (type) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { finalDate, initialDate, _user } = this.state

        const data = {
            initialDate,
            finalDate,
            CodeBranchOffice: _user?.Branch.CodeBranchOffice,
            type
        }
        enableSpinner(true);
        let responseApi = await apiClient.SearchBranchOfficeCreditNotes(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: responseApi.message });
            return
        }

        this.setState({
            BranchOfficeCreditNotes: responseApi.data || [],
        })
    }

    ShowDetailInvoiceBO = async (folio) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let data = {
            docsToPrintIds: [folio],
            typeDoc: 13
        }
        enableSpinner(true);
        let responseApi = await apiClient.getPrintDocsInfo(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            // this.CloseCreatedInvoiceActions();
            return;
        }
        await this.setState({
            docsToPrint: responseApi.data ?? [],
            typeDocPrint: 'OINV',
            ordersToAction: folio,
            EnableEditButton: false,
        });
        // await this.ShowPDFViewer();
        $("#pdfViewer").modal("show");
    }

    ShowDetailCreditNoteBO = async (folio) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let data = {
            docsToPrintIds: [folio],
            typeDoc: 14
        }
        enableSpinner(true);
        let responseApi = await apiClient.getPrintDocsInfo(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            // this.CloseCreatedInvoiceActions();
            return;
        }
        await this.setState({
            docsToPrint: responseApi.data ?? [],
            typeDocPrint: 'ORIN',
            ordersToAction: folio,
            EnableEditButton: false,
        });
        // await this.ShowPDFViewer();
        $("#pdfViewer").modal("show");
    }

    CloseCreatedInvoiceActions = async () => {
        // 

    }

    ValidateSessions = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { EmployeesCashCutReports } = this.state;

        if (EmployeesCashCutReports.length > 0) {
            let flag = false;
            for (let index = 0; index < EmployeesCashCutReports.length; index++) {
                const session = EmployeesCashCutReports[index];
                if (session.sessionStatus === 'O') {
                    flag = true;
                }
            }
            if (flag) {
                showAlert({ type: "error", message: `HAY SESIONES ACTIVAS. VERIFICA QUE EL CAJERO RESPONSABLE REALICE SU CORTE DE CAJA`, timeout: 10000 });
                return
            } else {
                $("#closureModal").modal("show");
            }
        } else {
            showAlert({ type: "info", message: `NO HAY SESIONES ACTIVAS EN TU SUCURSAL. NO PUEDES GENERAR CORTES`, timeout: 10000 });
            return
        }

    }

    SearchLastCashCuts = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const { userSearch, finalDate, initialDate } = this.state
        if (userSearch === '') {
            showAlert({ type: "error", message: `Aun no has seleccionado un usuario para a buscar.` });
            return
        }
        const data = {
            userSearch,
            initialDate,
            finalDate
        }

        enableSpinner(true);
        const responseApi = await apiClient.searchLastCashCuts(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return
        }

        this.setState({
            cashCutsRecords: responseApi.data || []
        })
    }

    ShowCashCutModal = async (idWorkShift, recordData) => {
        await this.GetBoxCut(idWorkShift, recordData)
        $("#cashCutModal").modal("show");
    }

    GetBoxCut = async (idWorkShift, recordData) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        const responseApi = await apiClient.partialCut(idWorkShift);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }

        await this.setState({
            cashCut: responseApi.data.reportcashCut || "",
            totalCashCut: Number(responseApi.data.totalCashCut) || 0,
            totalAmountSales: Number(responseApi.data.totalAmountSales) || 0,
            numSalesCashCut: Number(responseApi.data.numSales) || 0,
            objCharge: responseApi.data.objCharge || {},
            extraPaymentsCashCut: responseApi.data.extraPayments,
            headerCashCut: recordData,
            moneyOuts: responseApi.data.moneyOuts,
            moneyEntries: responseApi.data.moneyEntries,
        });
        this.GetBlindCut(idWorkShift);
    };

    GetBlindCut = async (idWorkShift) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        const responseApi = await apiClient.BlindCut(idWorkShift);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "info", message: `${responseApi.message}` });
        }
        await this.setState({
            BlindCutByIdSession: responseApi.data.BlindCut || [],
        })
    }

    ShowDetailCutUser = async (idSession, date) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const data = {
            idSession
        }
        enableSpinner(true);
        const responseApi = await apiClient.DetailCutUser(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        responseApi.data.Date = date;
        await this.setState({
            docsToPrint: [responseApi.data],
            typeDocPrint: 'RECU',
            // ordersToAction: folio,
            EnableEditButton: false,
            idSessionSelected: idSession
        });

        $("#pdfViewer").modal("show");
    }

    SearchLastBOEmployeesCashCuts = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const { finalDate, initialDate, _user} = this.state
        const startDate = new Date(initialDate);
        const endDate = new Date(finalDate);
        const datesBetween = [];
        let simulateResult = [];
        let currentDate = startDate;

        enableSpinner(true);
        while (currentDate <= endDate) {
            datesBetween.push(new Date(currentDate).toISOString());
            currentDate.setDate(currentDate.getDate() + 1);
        }
        for (let index = 0; index < datesBetween.length; index++) {
            const dateData = datesBetween[index];
            const realDate = (dateData).split('T')
            const data = {
                folio: `${_user?.Branch.CodeBranchOffice}-${realDate[0] ?? ''}CS`,
                date: realDate[0],
                codeBO: _user?.Branch.CodeBranchOffice
            }
            simulateResult.push(data);
        }
        enableSpinner(false);
        await this.setState({
            simulateResult
        })
    }

    GetCashCutBOByDate = async (date) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const data = {
            date
        }
        enableSpinner(true);
        const responseApi = await apiClient.SearchLastBOEmployeesCashCuts(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }

        await this.setState({
            docsToPrint: [responseApi.data] ?? [],
            typeDocPrint: 'BOECC',
            EnableEditButton: false,
            showPDFViewer: !this.state.showPDFViewer,
            ShowExtraActions: false
        })
        $("#pdfViewer").modal("show");
    }


    //#region ########## MAIL FUNCTIONS  #################################################

    RefreshSendMailModel = (sendMailModel) => {
        this.setState({ sendMailModel })
    }

    SendDocsByEmail = async (docsStruct) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { sendMailModel, docsToPrint, typeDocPrint } = this.state
        var value = docsStruct.innerHTML;
        var objToSend = JSON.stringify(value);
        let infoFolio = await _generalFunctions.getDocInfoByFolio(docsToPrint[0].docHeader.infoByFolio.folio ?? '')
        sendMailModel.docEntry = infoFolio.DocEntry

        let data = {
            sendMailModel,
            docsStruct: objToSend,
            typeDoc: typeDocPrint,
            objType: infoFolio.num,
            infoDoc: [{
                cardCode: docsToPrint[0].docHeader.responseHeader.CardCode ?? '',
                folio: docsToPrint[0].docHeader.infoByFolio.folio ?? ''
            }]
        }

        enableSpinner(true);
        let responseApi = await apiClient.SendPrintDocsByEmail(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message ?? ''}` });
            return;
        }
        showAlert({ type: "success", message: `${responseApi.message ?? ''}` });
    }

    OpenSendMailModal = () => {
        $("#pdfSendMailModal").modal("show");
    }
    //#endregion

    PrintEmployeesBOCut = async (scrt) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        const responseApi = await apiClient.PrintEmployeesBOCutAll();
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message ?? ''}` });
            return;
        }

        await this.setState({
            docsToPrint: [responseApi.data] ?? [],
            typeDocPrint: (scrt ? 'SCRT' : 'BOECC'),
            EnableEditButton: false,
            showPDFViewer: !this.state.showPDFViewer,
            ShowExtraActions: false
        });
        $("#pdfViewer").modal("show");
    }

    ShowFormatToPrint = async () => {
        await this.setState({
            printhide: !this.state.printhide,
        });
    };

    render() {
        const {
            TODAY,
            EmployeesCashCutReports,
            CommentCloseDoc,
            initialDate,
            finalDate,
            BranchOfficeInvoices,
            docsToPrint,
            typeDocPrint,
            _user,
            sendMailModel,
            BranchOfficeCreditNotes,
            users,
            userSearch,
            cashCutsRecords,
            cashCut,
            objCharge,
            totalCashCut,
            totalAmountSales,
            numSalesCashCut,
            extraPaymentsCashCut,
            headerCashCut,
            moneyOuts,
            moneyEntries,
            printhide,
            simulateResult,
            MonthDocument,
            bankOptions = [],
        } = this.state

        let mailTools = {
            sendMailModel: sendMailModel,
            RefreshSendMailModel: this.RefreshSendMailModel,
            SendDocsByEmail: this.SendDocsByEmail
        }

        return (
            <div className="content">
                <NavBar props={this.props} logoCounter={true} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'CIERRES DE SUCURSALES'} url1={'#'} />
                <div style={{ marginLeft: "4rem" }}>
                    <div className="row ml-3 mr-3">
                        <h3 className="ml-3 mb-2 mt-3">Cierres de sucursales</h3>
                    </div>
                    <div className='row m-3'>
                        <div className='col-6 '>

                        </div>
                        <div className='col-6 text-right'>
                            <div className='row '>
                                <div className='col-md-6 '>
                                    <div className="input-group text-right">
                                        {/* <div className="input-group-prepend">
                                            <span className="input-group-text"><strong>Mes del corte: </strong></span>
                                        </div>
                                        <select
                                            name="select"
                                            className="form-control"
                                            style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                            value={MonthDocument}
                                            onChange={(event) => this.ChangeDocDate(event.target.value)}>
                                            <option value="">Selecciona un mes</option>
                                            {months.map((month, index) => {
                                                return (
                                                    <option value={index}>{month}</option>
                                                )
                                            })}
                                        </select> */}
                                    </div>
                                </div>
                                <div className='col-md-6 '>
                                    <div className='row '>
                                    </div>
                                   
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className='m-3'>
                        <nav className='mt-4 ml-3' >
                            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                <a
                                    className={"nav-item nav-link font-weight-bold text-secondary active"}
                                    id="nav-profile-tab-ListChashCutToMake"
                                    data-toggle="tab"
                                    href="#dataListChashCutToMake"
                                    role="tab"
                                    aria-controls="dataListChashCutToMake"
                                >
                                    Cortes Pendientes
                                </a>
                                <a
                                    className={"nav-item nav-link font-weight-bold text-secondary"}
                                    id="nav-home-tab-employee-CashCuts"
                                    data-toggle="tab"
                                    href="#employee-CashCuts"
                                    role="tab"
                                    aria-controls="employee-CashCuts"
                                // onClick={() => this.SearchBranchOfficeCreditNotes(2)}
                                >
                                    Cortes de sucursales
                                </a>
                            </div>
                        </nav>
                        <div className="tab-content pl-3 responsive-row" style={{ textAlign: 'left' }}>

                            {/* Cortes Pendientes */}
                            <div
                                className="w-100 tab-pane active"
                                id="dataListChashCutToMake"
                                role="tabpanel"
                                aria-labelledby="nav-profile-tab-List"
                                style={{ paddingTop: 5, border: "1px solid #00000020", borderTop: "none", borderRadius: "0.25rem" }}>

                                <div className="row m-3">
                                    <div className="col-xl-12 mb-4 mb-xl-0 responsive-row">
                                        <div className="row p-1">
                                            <div className="col-12 col-md-5 mb-2 responsive-row">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text fw-bold">
                                                            <span className="d-none d-xl-inline"><strong>Fecha actual:</strong></span>
                                                            <span className="d-inline d-xl-none"><strong>F.Actual:</strong></span>
                                                        </span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        // disabled={true}
                                                        value={TODAY}
                                                        max='9999-12-31'
                                                    />
                                                </div>
                                            </div>
                                            {/* <div className='col-md-9 text-right'>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary ml-2"
                                                    style={{ backgroundColor: "rgb(233, 236, 239)", color: "rgb(73, 80, 87)", border: "1px solid rgb(206, 212, 218)" }}
                                                    onClick={() => this.PrintEmployeesBOCut(false)} >
                                                    <i className="fa fa-print mr-2" aria-hidden="true" />
                                                    Cortes de sucursal
                                                </button>
                                            </div> */}
                                        </div>
                                        <div className='card scrollTableClosures mb-3' >
                                            <table className="table table-striped table-hover" id="inData" >
                                                <thead className='sticky-headerPOS' style={{ backgroundColor: "white" }}>
                                                    <tr>
                                                        <th className="text-center">Código</th>
                                                        <th className="text-left">Sucursal</th>
                                                        <th className="text-left">Usuario</th>                                                        
                                                        <th className="text-center">Hora</th>
                                                        <th className="text-center">Estatus</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr >
                                                        <td className="text-center">{"A00"}</td>
                                                        <td className="text-left">{"AEROPUERTO"}</td>
                                                        <td className="text-left">{"---"}</td>
                                                        <td className="text-center">{moment(new Date()).format('hh:mm:ss')}</td>
                                                       
                                                        <td className="text-center">
                                                            <i class={`${true ? 'fa fa-exclamation-triangle' : 'fa fa fa-check'} mr-2`} aria-hidden="true" style={{ color: `${true ? "#eabf28" : "#28a745"}` }}></i>
                                                            {true ? 'Corte pendiente' : 'Corte realizado'}
                                                        </td>
                                                    </tr>
                                                    <tr >
                                                        <td className="text-center">{"M00"}</td>
                                                        <td className="text-left">{"MATRIZ"}</td>
                                                        <td className="text-left">{"Israel Castro"}</td>
                                                        <td className="text-center">{moment(new Date()).format('hh:mm:ss')}</td>
                                                       
                                                        <td className="text-center">
                                                            <i class={`${false ? 'fa fa-exclamation-triangle' : 'fa fa fa-check'} mr-2`} aria-hidden="true" style={{ color: `${false ? "#eabf28" : "#28a745"}` }}></i>
                                                            {true ? 'Corte pendiente' : 'Corte realizado'}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Cortes de  sucursal*/}
                            <div
                                className="w-100 table-scroll tab-pane "
                                id="employee-CashCuts"
                                role="tabpanel"
                                aria-labelledby="nav-home-tab-employee-CashCuts"
                                style={{ paddingTop: 5, border: "1px solid #00000020", borderTop: "none", borderRadius: "0.25rem" }}>
                                <div className="row m-3">
                                    <div className="col-xl-12 mb-4 mb-xl-0">
                                        <div className="row p-1">
                                            <div className="col-12 col-md-4 col-lg-4 col-xl-4 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Sucursal: </strong></span>
                                                    </div>
                                                    <select
                                                        name="select"
                                                        className="form-control"
                                                        style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                                        value={userSearch || ""}
                                                        onChange={(event) => this.ChangeUserToSearch(event.target.value)}
                                                    >
                                                        <option value="">Seleccionar</option>
                                                        {!!users && users.map((user, index) => {
                                                            return (
                                                                <option key={index} value={user.USERID}>{user.U_NAME} - {user.E_Mail} </option>
                                                            )
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 col-lg-3 col-xl-3 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Desde: </strong></span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        value={initialDate}
                                                        onChange={(event) => this.ChangeInitialDate(event)}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.SearchLastCashCuts();
                                                            }
                                                        }}
                                                        max='9999-12-31'
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 col-lg-3 col-xl-3 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Hasta: </strong></span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        value={finalDate}
                                                        onChange={(event) => this.ChangeFinalDate(event)}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.SearchLastCashCuts();
                                                            }
                                                        }}
                                                        max='9999-12-31'
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 col-lg-2 col-xl-2 mb-2 text-right" >
                                                <div className='input-group-append '>
                                                    <button type="button" className="btn btn-primary ml-0" onClick={() => this.SearchLastCashCuts()} style={{ backgroundColor: "rgb(233, 236, 239)", color: "rgb(73, 80, 87)", border: "1px solid rgb(206, 212, 218)" }}>
                                                        <i className="fa fa-search mr-2" aria-hidden="true" />
                                                        Buscar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='card scrollTableClosures' >
                                            <table className="table table-striped table-hover" id="inData" >
                                                <thead className='sticky-headerPOS' style={{ backgroundColor: "white" }}>
                                                    <tr>
                                                        <th className="text-center">Fecha</th>
                                                        <th className="text-center">Sucursal</th>
                                                        <th className="text-center">Usuario</th>
                                                        <th className="text-center">F. de consolidador</th>
                                                        <th className="text-center">F. de mostrador</th>
                                                        <th className="text-center">NC de consolidador</th>
                                                        <th className="text-center">NC de mostrador</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    
                                                    <tr >
                                                        <td className="text-center">{moment(new Date()).format('YYYY-MM-DD')}</td>
                                                        <td className="text-center">{"Matriz"}</td>
                                                        <td className="text-center">{"Sistema"}</td>
                                                        <td className="text-center">
                                                            <button 
                                                                className = "btn btn-active"
                                                                style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}>
                                                                <i className="fa fa-print"></i>
                                                            </button>
                                                        </td>
                                                        <td className="text-center">
                                                            <button 
                                                                className = "btn btn-active"
                                                                style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}>
                                                                <i className="fa fa-print"></i>
                                                            </button>
                                                        </td>
                                                        <td className="text-center sticky-column">
                                                            <button 
                                                                className = "btn btn-active"
                                                                style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}>
                                                                <i className="fa fa-print"></i>
                                                            </button>
                                                        </td>
                                                        <td className="text-center sticky-column">
                                                            <button 
                                                                className = "btn btn-active"
                                                                style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}>
                                                                <i className="fa fa-print"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    
                                                    <tr className='noSearch hide'>
                                                        <td colSpan="7"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>


                            
                           

                        </div>
                    </div>
                </div>
                <ClosureModal
                    CommentCloseDoc={CommentCloseDoc}
                    ChangeCommentCloseDoc={this.ChangeCommentCloseDoc}
                    BranchOfficeGeneralCut={this.BranchOfficeGeneralCut}
                />

                <ConsolidateDocsModal
                    responseBOC

                />

                <PdfViewer
                    DocsToPrint={docsToPrint}
                    TypeDoc={typeDocPrint}
                    EnableEditButton={false}
                    Editable={false}
                    ChangeEditableMode={() => { }}
                    EditableDocModel={{}}
                    RefreshDocModel={() => { }}
                    SaveChanges={() => { }}
                    UploadDoc={() => { }}
                    EditParam1={false}
                    ShowPDFViewer={this.CloseCreatedInvoiceActions}
                    CreateDocument={() => { }}
                    OpenMailModal={this.OpenSendMailModal}
                    ItsFirme={true}
                    user={_user}
                    Counter={true}
                    MailTools={mailTools}
                    printhide={printhide}
                    ShowFormatToPrint={this.ShowFormatToPrint}
                    idSessionSelected={this.state.idSessionSelected}
                    reprint={false}
                />


                <CashCutModal
                    ShowCashCutModal={this.ShowCashCutModal}
                    CashCut={cashCut}
                    ObjCharge={objCharge}
                    TotalCashCut={totalCashCut}
                    TotalAmountSales={totalAmountSales}
                    NumVentas={numSalesCashCut}
                    extraPaymentsCashCut={extraPaymentsCashCut}
                    moneyEntries={moneyEntries}
                    moneyOuts={moneyOuts}
                    headerCashCut={headerCashCut}
                    BranchOfficeGeneralCut={this.BranchOfficeGeneralCut}
                    CloseWorkShift={() => { }}
                    GotoDashboard={() => { }}
                    lastDaySession={true}
                    HideTotalCashCutsActions={true}
                    _user={_user}
                    blindCashCut={false}
                    BlindCutByIdSession={this.state.BlindCutByIdSession}
                    bankOptions={bankOptions}
                />

                <ListModal
                    IdModal={"failCardCodes"}
                    HeaderTitle={'Socios información por corregir'}
                    Body={this.bodyFailCardCodes()}
                    CloseActions={() => {
                        $("#failCardCodes").modal("hide");
                        this.setState({
                            FailCardCodes: []
                        })

                    }}
                />
            </div>
        );
    }

    bodyFailCardCodes = () => {
        const { FailCardCodes } = this.state
        return (
            <div className="container">
                <div className="row justify-content-around">
                    <div className="col-12">
                        <div className="w-100 table-scroll tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" style={{ marginBottom: 0, minheight: 400, maxHeight: 500 }}>
                            <table className="table response" style={{ marginBottom: 0 }}>
                                <tr>
                                    <td className="sticky-header table-header-yellow" style={{ textAlign: "center" }}>Código cliente (CardCode)</td>
                                </tr>
                                {FailCardCodes && FailCardCodes.length > 0 &&
                                    FailCardCodes.map((partner, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className="text-center">{partner || ''}</td>

                                            </tr>
                                        )
                                    })}
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (store) => {
    return {
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        enableSpinner: (value) =>
            dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BranchClosuresView);


// export default ;
